import { render, staticRenderFns } from "./FacilityIssue.vue?vue&type=template&id=2369e216&scoped=true&"
import script from "./FacilityIssue.vue?vue&type=script&lang=js&"
export * from "./FacilityIssue.vue?vue&type=script&lang=js&"
import style0 from "./FacilityIssue.vue?vue&type=style&index=0&id=2369e216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369e216",
  null
  
)

export default component.exports